import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../ModalConversion';
import AccountsUsersService from '../../../services/AccountsUsersService';

const EMPTY = {
    companyName: '', bankName: '', addressRecipient: '', interbankKey: '', accountNumber: '',
    branchOffice: '', iban: '', swift: '', intermediaryBank: '', intermediaryAccount: '',
    intermediarySwift: '', idFiscal: '', routingNumber: '',
};

export function BankInfoModal({ isOpen, onClose, account, onSaved }) {
    const [form, setForm] = useState(EMPTY);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen && account) {
            setError('');
            setLoading(true);
            AccountsUsersService.getBilling(account.prefix)
                .then((res) => {
                    const bi = res.bank_info || {};
                    setForm({
                        companyName: bi.companyName || '',
                        bankName: bi.bankName || '',
                        addressRecipient: bi.addressRecipient || '',
                        interbankKey: bi.interbankKey || '',
                        accountNumber: bi.accountNumber || '',
                        branchOffice: bi.branchOffice || '',
                        iban: bi.iban || '',
                        swift: bi.swift || '',
                        intermediaryBank: bi.intermediaryBank || '',
                        intermediaryAccount: bi.intermediaryAccount || '',
                        intermediarySwift: bi.intermediarySwift || '',
                        idFiscal: bi.idFiscal || '',
                        routingNumber: bi.routingNumber || '',
                    });
                })
                .catch((e) => setError(e.message))
                .finally(() => setLoading(false));
        }
    }, [isOpen, account]);

    const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSaving(true);
        try {
            await AccountsUsersService.setBankInfo({
                prefix: account.prefix,
                ...Object.keys(EMPTY).reduce((acc, k) => ({ ...acc, [k]: form[k].trim() }), {}),
            });
            if (onSaved) onSaved('Datos bancarios guardados correctamente');
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    const fields = [
        { key: 'companyName', label: 'Nombre de la empresa', required: true, span: 6 },
        { key: 'bankName', label: 'Banco', span: 6 },
        { key: 'addressRecipient', label: 'Dirección del beneficiario', span: 12 },
        { key: 'interbankKey', label: 'Clave interbancaria (CLABE)', span: 6 },
        { key: 'accountNumber', label: 'Número de cuenta', span: 6 },
        { key: 'branchOffice', label: 'Sucursal', span: 6 },
        { key: 'iban', label: 'IBAN', span: 6 },
        { key: 'swift', label: 'SWIFT', span: 6 },
        { key: 'intermediaryBank', label: 'Banco intermediario', span: 6 },
        { key: 'intermediaryAccount', label: 'Cuenta intermediaria', span: 6 },
        { key: 'intermediarySwift', label: 'SWIFT intermediario', span: 6 },
        { key: 'idFiscal', label: 'ID fiscal', span: 6 },
        { key: 'routingNumber', label: 'Routing number', span: 6 },
    ];

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <div className="p-4">
                <h4 className="text-white mb-1">Datos bancarios</h4>
                <div className="text-white-50 small mb-3">
                    {account ? `${account.pub_name} (${account.prefix})` : ''}
                </div>

                {loading ? (
                    <div className="text-center py-4 text-white-50"><FontAwesomeIcon icon={faSpinner} spin /> Cargando...</div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && <div className="alert alert-danger py-2">{error}</div>}
                        <div className="row g-3">
                            {fields.map((f) => (
                                <div className={`col-md-${f.span}`} key={f.key}>
                                    <label className="form-label text-white-50">{f.label}{f.required ? ' *' : ''}</label>
                                    <input
                                        type="text"
                                        className="form-control bg-dark text-white border-secondary py-2"
                                        value={form[f.key]}
                                        onChange={(e) => set(f.key, e.target.value)}
                                        required={f.required}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-4">
                            <button type="button" className="btn btn-outline-secondary px-4 rounded-pill" onClick={onClose} disabled={saving}>Cancelar</button>
                            <button type="submit" className="btn btn-success px-4 rounded-pill" disabled={saving}>
                                {saving && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                                Guardar datos bancarios
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </Modal>
    );
}

export default BankInfoModal;